export enum ScriptKeyPreset {
  MsdkJsAdapter = 'msdkJsAdapter',
  // NOTE: add more here
}
